const BODY_MODAL_CLASS = "is-haitao-shop-landing-modal-open";

const initWechatModal = (root) => {
    const modal = root.querySelector("[data-wechat-modal]");
    const openButtons = root.querySelectorAll("[data-wechat-modal-open]");
    if (!modal || !openButtons.length) return;

    const closeButtons = modal.querySelectorAll("[data-wechat-modal-close]");
    const closeButton = modal.querySelector(".wechat-modal__close");
    const focusableSelector =
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    let activeButton = null;

    const closeModal = () => {
        modal.classList.remove("is-open");
        modal.setAttribute("aria-hidden", "true");
        modal.setAttribute("inert", "");
        document.body.classList.remove(BODY_MODAL_CLASS);
        activeButton?.focus();
        activeButton = null;
    };

    const openModal = (event) => {
        event.preventDefault();
        activeButton = event.currentTarget;
        modal.classList.add("is-open");
        modal.setAttribute("aria-hidden", "false");
        modal.removeAttribute("inert");
        document.body.classList.add(BODY_MODAL_CLASS);
        closeButton?.focus();
    };

    const keepFocusInside = (event) => {
        if (event.key !== "Tab") return;

        const focusableElements = [
            ...modal.querySelectorAll(focusableSelector),
        ];
        const firstElement = focusableElements[0];
        const lastElement = focusableElements.at(-1);

        if (!firstElement || !lastElement) {
            event.preventDefault();
            return;
        }

        if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
        }
    };

    openButtons.forEach((button) =>
        button.addEventListener("click", openModal),
    );
    closeButtons.forEach((button) =>
        button.addEventListener("click", closeModal),
    );
    modal.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
            closeModal();
            return;
        }

        keepFocusInside(event);
    });
};

export { initWechatModal };
